
document.querySelectorAll('[data-event-feed]').forEach(async (container) => {
    const itemsContainer = container.querySelector('.event-feed__items');
    const emptyContainer = container.querySelector('.event-feed__empty');
    const moreContainer = container.querySelector('.event-feed__more');
    const clearButton = container.querySelector('.event-feed__filter-clear button');
    const filterKeywords = container.querySelector('.event-feed__filter input[name="keywords"]');
    const filterType = container.querySelector('.event-feed__filter *[name="type"]');
    const filterFeatured = container.querySelector('.event-feed__filter *[name="featured"]');

    let currentPage = 0;
    const feedUrl = container.getAttribute('data-event-feed');

    itemsContainer.innerHTML = '';

    const moreButton = moreContainer.firstElementChild;
    const moreButtonTitle = moreButton.querySelector('span');
    const moreButtonLabel = moreButtonTitle.innerText;
    const updateMoreButton = (loading, hide = false) => {
        moreContainer.style.display = hide ? 'none' : 'block';

        if (loading) {
            moreButton.classList.add('loading');
            moreButtonTitle.innerText = moreButtonTitle.getAttribute('data-loading');
        } else {
            moreButton.classList.remove('loading');
            moreButtonTitle.innerText = moreButtonLabel;
        }
    }

    const loadItems = async (page = 1) => {
        updateMoreButton(true)
        emptyContainer.style.display = 'none';
        clearButton.style.display = (filterKeywords.value !== '' || filterType.value !== '' || filterFeatured.checked) ? 'block' : 'none';

        if (page === 1) {
            itemsContainer.innerHTML = '';
        }

        const searchParams = new URLSearchParams();
        if (filterKeywords.value) searchParams.set('keywords', filterKeywords.value);
        if (filterType.value) searchParams.set('type', String(filterType.value));
        if (filterFeatured.checked) searchParams.set('featured', String(filterFeatured.value));
        if (page > 1) searchParams.set('page', String(page));

        const currLocation = new URL(location.href);
        currLocation.hash = searchParams.toString();
        history.replaceState({}, '', currLocation.toString());

        const feed = new URL(feedUrl);
        searchParams.set('pageId', feed.searchParams.get('pageId'));
        feed.search = searchParams.toString();

        const data = await (await fetch(feed.toString())).json();

        if (data.events.length > 0) {
            data.events.forEach((event) => {
                const el = document.createElement('div');
                el.innerHTML = event;

                itemsContainer.append(el.firstElementChild);
            });

            updateMoreButton(false, data.perPage * page >= data.total);
        } else if (page === 1) {
            emptyContainer.style.display = 'block';
            updateMoreButton(false, true);
        }

        currentPage = page;
    };

    container.querySelector('.event-feed__pagination').remove()
    container.querySelector('.event-feed__filter').style.display = 'inherit';

    let keyboardDelay;
    filterKeywords.addEventListener('input', () => {
        clearTimeout(keyboardDelay);
        keyboardDelay = setTimeout(() => {
            loadItems();
        }, 300)
    });

    filterType.addEventListener('change', () => { loadItems(); });
    filterFeatured.addEventListener('change', () => { loadItems(); });

    clearButton.addEventListener('click', () => {
        filterKeywords.value = '';
        filterKeywords.detect();
        filterType.value = '';
        filterFeatured.checked = false;
        loadItems();
    });

    moreContainer.firstElementChild.addEventListener('click', (e) => {
        e.preventDefault();
        loadItems(currentPage+1);
    });

    const currLocation = new URL(location.href);
    if (currLocation.hash) {
        const hash = new URLSearchParams(currLocation.hash.substring(1));
        const page = hash.get('page');
        const offset = history.state && history.state['event-feed-offset'] || undefined

        filterKeywords.value = hash.get('keywords') || '';
        filterKeywords.detect();
        filterType.value = hash.get('type') || '';
        filterFeatured.checked = !!hash.get('featured');

        await loadItems();

        if (page > 1) {
            for (let i = 1; i <= page; i++) {
                await loadItems(i);
            }

            if (offset) {
                window.scroll(0, offset);
            }
        }
    } else {
        await loadItems();
    }

    window.addEventListener('beforeunload', () => {
        history.replaceState({ 'event-feed-offset': window.scrollY }, '', location.href);
    });
})
